import { styled } from '@acko-tech/building-blocks.ui.common';

export const LandingPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;
